import FSCss from "../../css/overview.module.css";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";

const ConsoleTopBar = ({
  history,
}) => {
  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      <div className={FSCss.listPageheader}>
        <div className={FSCss.headerLeftContainer}>
        </div>
        <div className={FSCss.headerRightContainer}>
          
          &ensp;
          <Button
            btnColor={buttoncss.secondary}
            label="Link Registers"
            onClick={() => {
              history.push("/link-register");
              //   handleNew();
            }}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Finalise FS"
            //   onClick={handleFilter}
            onClick={() => {
              history.push("/finalize-fs");
              //   handleNew();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ConsoleTopBar;
